/* ===========================================
   JOGA DANO — Theme JS
   =========================================== */

document.addEventListener('DOMContentLoaded', () => {

  // ── Mobile Nav ──────────────────────────
  const hamburger = document.getElementById('hamburger');
  const mobileNav = document.getElementById('mobile-nav');
  const mobileClose = document.getElementById('mobile-nav-close');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      mobileNav.classList.add('is-open');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', () => {
      mobileNav.classList.remove('is-open');
      hamburger && hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  }

  // ── Wishlist toggle ──────────────────────
  document.querySelectorAll('.product-card-wishlist').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      btn.classList.toggle('is-active');
      const svg = btn.querySelector('svg path, svg polygon');
      if (btn.classList.contains('is-active')) {
        btn.style.background = 'var(--clr-primary)';
        btn.style.color = 'white';
        btn.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        btn.style.background = '';
        btn.style.color = '';
        btn.setAttribute('aria-label', 'Add to wishlist');
      }
    });
  });

  // ── Sticky header shadow ─────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10
        ? '0 4px 20px rgba(0,0,0,0.12)'
        : '0 2px 8px rgba(0,0,0,0.08)';
    }, { passive: true });
  }

  // ── Newsletter form ──────────────────────
  const newsletterForm = document.getElementById('newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', (e) => {
      const btn = newsletterForm.querySelector('button[type="submit"]');
      if (btn) { btn.textContent = 'Subscribing...'; btn.disabled = true; }
    });
  }

  // ── Product Page ──────────────────────────
  const productForm = document.querySelector('.product-form');
  if (productForm) {
    const jsonEl = document.querySelector('[data-product-json]');
    const productData = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    const variantIdInput = productForm.querySelector('[data-product-variant-id]');
    const priceEl = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-product-price-compare]');
    const installmentEl = document.querySelector('[data-product-installment]');
    const stockEl = document.querySelector('[data-product-stock]');
    const addBtn = document.querySelector('[data-product-add-btn]');
    const addBtnLabel = document.querySelector('[data-add-btn-label]');
    const buyItNowBtn = document.querySelector('.product-buyitnow-btn');
    const mainImage = document.getElementById('product-main-image');

    const selectedOptions = {};
    document.querySelectorAll('.product-option').forEach((optionEl) => {
      const idx = optionEl.getAttribute('data-option-index');
      const activeBtn = optionEl.querySelector('.is-active');
      if (activeBtn) selectedOptions[idx] = activeBtn.getAttribute('data-value');
    });

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function findMatchingVariant() {
      if (!productData) return null;
      return productData.variants.find((variant) => {
        const opts = [variant.option1, variant.option2, variant.option3];
        return Object.keys(selectedOptions).every((idx) => {
          return opts[parseInt(idx, 10)] === selectedOptions[idx];
        });
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (installmentEl) installmentEl.textContent = formatMoney(Math.round(variant.price / 4));
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (stockEl) {
        if (variant.available) {
          stockEl.classList.remove('product-stock--out');
          stockEl.innerHTML = '<span class="product-stock-dot"></span> In stock — Ships within 24 hours';
        } else {
          stockEl.classList.add('product-stock--out');
          stockEl.innerHTML = 'Currently unavailable';
        }
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (buyItNowBtn) buyItNowBtn.disabled = !variant.available;
      if (addBtnLabel) addBtnLabel.textContent = variant.available ? 'Add to Cart' : 'Sold Out';

      // Swap main image if this variant has its own image
      if (variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image.src.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_1400x$1$2');
      }
    }

    document.querySelectorAll('.product-swatch, .product-size-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const optionEl = btn.closest('.product-option');
        const idx = btn.getAttribute('data-option-index');
        const value = btn.getAttribute('data-value');

        optionEl.querySelectorAll('.product-swatch, .product-size-btn').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const valueDisplay = optionEl.querySelector('.product-option-value');
        if (valueDisplay) valueDisplay.textContent = ': ' + value;

        selectedOptions[idx] = value;
        const variant = findMatchingVariant();
        if (variant) updateForVariant(variant);
      });
    });

    // Gallery thumbnail switching
    document.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        document.querySelectorAll('[data-product-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (mainImage) mainImage.src = thumb.getAttribute('data-full-src');
      });
    });

    // Quantity stepper
    const qtyInput = document.getElementById('product-qty-input');
    const qtyDecrease = document.querySelector('[data-qty-decrease]');
    const qtyIncrease = document.querySelector('[data-qty-increase]');
    if (qtyInput && qtyDecrease && qtyIncrease) {
      qtyDecrease.addEventListener('click', () => {
        const val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = val;
      });
      qtyIncrease.addEventListener('click', () => {
        const val = (parseInt(qtyInput.value, 10) || 1) + 1;
        qtyInput.value = val;
      });
    }

    // Add to Cart via AJAX
    productForm.addEventListener('submit', (e) => {
      const submitter = e.submitter;
      if (submitter && submitter.name === 'checkout') return; // let Buy It Now submit normally

      e.preventDefault();
      if (!addBtn || addBtn.disabled) return;

      const formData = new FormData(productForm);
      addBtn.disabled = true;
      if (addBtnLabel) addBtnLabel.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then((res) => res.json())
        .then(() => fetch('/cart.js').then((r) => r.json()))
        .then((cart) => {
          const cartCountEl = document.querySelector('.cart-count');
          const headerCartBtn = document.querySelector('a[href*="/cart"].header-icon-btn');
          if (cartCountEl) {
            cartCountEl.textContent = cart.item_count;
          } else if (headerCartBtn && cart.item_count > 0) {
            const span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = cart.item_count;
            headerCartBtn.appendChild(span);
          }
          addBtn.classList.add('is-added');
          if (addBtnLabel) addBtnLabel.textContent = 'Added ✓';
          setTimeout(() => {
            addBtn.classList.remove('is-added');
            if (addBtnLabel) addBtnLabel.textContent = 'Add to Cart';
            addBtn.disabled = false;
          }, 1600);
        })
        .catch(() => {
          if (addBtnLabel) addBtnLabel.textContent = 'Add to Cart';
          addBtn.disabled = false;
        });
    });
  }

  // ── Product accordion (Description / Fabric & Care / Shipping) ──
  document.querySelectorAll('.product-accordion-item').forEach((item) => {
    const trigger = item.querySelector('.product-accordion-trigger');
    if (!trigger) return;
    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');
      item.closest('.product-accordion').querySelectorAll('.product-accordion-item').forEach((i) => i.classList.remove('is-open'));
      if (!isOpen) item.classList.add('is-open');
    });
  });

  // ── Frequently Bought Together — Add Bundle to Bag ──
  const fbtAddBtn = document.querySelector('[data-fbt-add]');
  if (fbtAddBtn) {
    fbtAddBtn.addEventListener('click', () => {
      const ids = fbtAddBtn.getAttribute('data-variant-ids').split(',').filter(Boolean);
      const items = ids.map((id) => ({ id: parseInt(id, 10), quantity: 1 }));
      fbtAddBtn.disabled = true;
      const originalText = fbtAddBtn.textContent;
      fbtAddBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      })
        .then((res) => res.json())
        .then(() => fetch('/cart.js').then((r) => r.json()))
        .then((cart) => {
          const cartCountEl = document.querySelector('.cart-count');
          if (cartCountEl) cartCountEl.textContent = cart.item_count;
          fbtAddBtn.textContent = 'Added ✓';
          setTimeout(() => {
            fbtAddBtn.textContent = originalText;
            fbtAddBtn.disabled = false;
          }, 1600);
        })
        .catch(() => {
          fbtAddBtn.textContent = originalText;
          fbtAddBtn.disabled = false;
        });
    });
  }

  // ── Scroll reveal animation ──────────────
  if ('IntersectionObserver' in window) {
    const style = document.createElement('style');
    style.textContent = `
      .reveal { opacity: 0; transform: translateY(24px); transition: opacity 0.5s ease, transform 0.5s ease; }
      .reveal.is-visible { opacity: 1; transform: none; }
    `;
    document.head.appendChild(style);

    const revealEls = document.querySelectorAll(
      '.product-card, .collection-card, .why-feature, .trust-item, .review-card'
    );
    revealEls.forEach(el => el.classList.add('reveal'));

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(el => observer.observe(el));
  }

});

/* ===========================================
   CART PAGE — per-row quantity steppers
   =========================================== */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cart-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input[type="number"]');
    const decrease = wrap.querySelector('[data-qty-decrease]');
    const increase = wrap.querySelector('[data-qty-increase]');
    if (!input) return;

    decrease && decrease.addEventListener('click', () => {
      const next = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
      input.value = next;
    });

    increase && increase.addEventListener('click', () => {
      const next = (parseInt(input.value, 10) || 0) + 1;
      input.value = next;
    });
  });
});

/* ===========================================
   PRODUCT PAGE — wishlist heart toggle (visual only)
   =========================================== */
document.addEventListener('DOMContentLoaded', () => {
  const wishlistBtn = document.querySelector('[data-product-wishlist]');
  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', () => {
      const isActive = wishlistBtn.classList.toggle('is-active');
      wishlistBtn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }
});
